<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>{{ description }}</v-card-text>

    <v-divider class="mx-4" />

    <div class="orangePcm--text info-number-text text-center">{{ size }}</div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    size: Number,
  },
}
</script>

<style scoped>
.info-number-text {
  font-size: 32px;
  font-weight: bold;
}
</style>
